import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import CustomTabs from "../../../../components/app/CustomTabs";
import PatientSectionWrapper from "../PatientSectionWrapper";

const PatientHealthRecord = () => {
  const TABS_DATA = [
    {
      value: "",
      label: "Medications",
    },
    {
      value: "immunization",
      label: "Immunization",
    },
    {
      value: "allergies ",
      label: "Allergies",
    },
    {
      value: "careplan",
      label: "Care Plan",
    },
    {
      value: "order",
      label: "Orders",
    },
    {
      value: "past-visit",
      label: "Past Visit",
    },
  ];

  const [activeTab, setActiveTab] = useState<string>(() => {
    const currentTab = location.pathname.split("/").pop();
    return currentTab == "health-record" ? "" : (currentTab as string);
  });
  const navigate = useNavigate();

  const handleTabChange = (v: string) => {
    setActiveTab(v);
    navigate(v);
  };

  return (
    <PatientSectionWrapper
      header={
        <CustomTabs
          tabsData={TABS_DATA}
          value={activeTab}
          onChange={handleTabChange}
        />
      }
    >
      <Outlet />
    </PatientSectionWrapper>
  );
};

export default PatientHealthRecord;
